<template lang="html">
  <v-container>
    <v-container>
      <div>
        <h1>{{ $t('metrics.TITLE') }}</h1>
      </div>
      <v-card>
        <div class="metrics">
          <div v-for="metric in metrics" class="metric" :key="metric.name">
            <div v-if="metric.img" class="image">
              <img :src="metric.img" />
            </div>
            <div v-else>
              <div class="value">
                {{ format(metric.value) }}
              </div>
              <div class="name">
                {{ metric.name }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
export default {
  methods: {
    format: new Intl.NumberFormat(navigator.language).format,
  },
  data() {
    return {
      metrics: [
        {
          name: this.$t('metrics.DOWNLOADS'),
          value: 101495,
        },
        {
          name: this.$t('metrics.COUNTRY'),
          img: require('../../public/img/Shayofae google analytics 2.png'),
        }
//        ,
//        {
//          name: this.$t('metrics.USERS'),
//          value: 9082,
//        }
      ],
    }
  },
}
</script>

<style lang="css" scoped>
h1 {
  padding: 1rem;
}
.metrics {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  align-items: center;
}
@media only screen and (max-width: 700px) {
  .metrics {
    flex-direction: column;
  }
  .metric {
    padding: 1rem 0;
  }
}
.metric img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.metric {
  flex: 1;
}

.value {
  font-size: 42px;
}
.image {
  display: flex;
  align-items: center;
}
</style>
